
import { Link } from 'react-router-dom';

export default function Footer() {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <img
              src="https://static.readdy.ai/image/939ff17c9dd5dcb6a914aa959dc9f824/56c2956145aae033251ab37a1ea52e57.png"
              alt="DFF Distribution"
              className="h-12 mb-6"
            />
            <p className="text-sm text-slate-300 leading-relaxed">
              B2B wholesale distribution supporting institutional supply chains with
              compliance, reliability, and operational discipline.
            </p>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-5">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  onClick={handleLinkClick}
                  className="whitespace-nowrap text-sm text-slate-300 hover:text-white transition-colors cursor-pointer"
                >
                  About DFF Distribution
                </Link>
              </li>
              <li>
                <Link
                  to="/industries"
                  onClick={handleLinkClick}
                  className="whitespace-nowrap text-sm text-slate-300 hover:text-white transition-colors cursor-pointer"
                >
                  Industries Served
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-5">Resources</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/contact"
                  onClick={handleLinkClick}
                  className="whitespace-nowrap text-sm text-slate-300 hover:text-white transition-colors cursor-pointer"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  onClick={handleLinkClick}
                  className="whitespace-nowrap text-sm text-slate-300 hover:text-white transition-colors cursor-pointer"
                >
                  Partnership Inquiries
                </Link>
              </li>
              <li>
                <a
                  href="#supplier"
                  className="whitespace-nowrap text-sm text-slate-300 hover:text-white transition-colors cursor-pointer"
                >
                  Supplier Information
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-5">Connect</h3>
            <p className="text-sm text-slate-300 mb-5 leading-relaxed">
              Discuss partnership opportunities and distribution capabilities.
            </p>
            <Link
              to="/contact"
              onClick={handleLinkClick}
              className="whitespace-nowrap inline-flex items-center px-6 py-2.5 bg-white text-slate-900 font-semibold rounded-lg hover:bg-slate-50 transition-all duration-300 hover:shadow-lg cursor-pointer text-sm"
            >
              Get in Touch
            </Link>
          </div>
        </div>

        <div className="border-t border-slate-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} DFF Distribution. All rights reserved. Veteran-Owned Business.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap text-slate-400 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
